export default __webpack_public_path__ + "static/media/rose.1b5b4bcf.jpg";